<template>
  <div
    v-if="loading"
    class="flex h-screen items-center justify-center"
  >
    <LoaderCircle
      class="animate-spin"
      :size="100"
    />
  </div>
</template>

<script setup lang="ts">
  import { LoaderCircle } from 'lucide-vue-next'
  import { genericErrorToast } from '@/lib/toasts'
  import { computed, onMounted, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { CLIENT_PORTAL } from '@/router/routes'
  import { OnboardingSessionsService } from '@/types/generated'

  const route = useRoute()
  const router = useRouter()

  const packageUuid = computed(() => route.params.package_uuid as string)
  const loading = ref(true)

  onMounted(async () => {
    try {
      const response = await OnboardingSessionsService.onboardingSessionsCreateFromPackageCreate({
        requestBody: {
          package_uuid: packageUuid.value
        }
      })

      if (response?.session_token) {
        await router.push({
          path: CLIENT_PORTAL.HOME,
          query: { session_token: response.session_token }
        })
      } else {
        genericErrorToast()
      }
    } catch (error) {
      console.error('Error creating onboarding session:', error)
      genericErrorToast()
    } finally {
      loading.value = false
    }
  })
</script>
